/**
 * Shim — real implementation lives in @vestra/agent-sdk.
 * @see packages/agent-sdk/src/contract/compaction-prompt.ts
 *
 * T9c widened the shim to the whole summarize request, not just its system half.
 * `scripts/compaction-eval` is the behavioural gate on this prompt, and it was
 * measuring a request the engine never sends: its own "Please summarize this
 * conversation" lead-in instead of {@link COMPACTION_USER}, and never the split-turn
 * section. A gate that scores a different prompt from the one in production cannot
 * catch a regression in production's.
 */
export {
  latestRequestSection,
  checkLatestRequest,
  LATEST_REQUEST_FORBIDDEN,
  type LatestRequestVerdict,
} from '@vestra/agent-sdk';

// The engine's own live-split rule, so the eval's summarize request carries the
// split-turn section on exactly the shapes production carries it on.
export { isLiveSplitTurn } from '@vestra/agent-sdk';

export {
  COMPACTION_SYSTEM,
  COMPACTION_USER,
  COMPACTION_SPLIT_TURN_SECTION,
  withSplitTurnInstructions,
} from '@vestra/agent-sdk';
